import { render, staticRenderFns } from "./Quadrature.vue?vue&type=template&id=4fd75947&"
import script from "./Quadrature.vue?vue&type=script&lang=js&"
export * from "./Quadrature.vue?vue&type=script&lang=js&"
import style0 from "./Quadrature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports